import {Component, EventEmitter, input, Input, Output} from '@angular/core';
import {ListaCompromissoDiario} from "../../../models/lista-compromisso-diario";
import {TarefaService} from "../../../services/tarefa-service";
import {ToastrService} from "ngx-toastr";
import {TarefasAgrupadasPorHora} from "../../../models/tarefas-agrupadas-por-hora";

@Component({
    selector: 'app-diario',
    templateUrl: './diario.component.html',
    styleUrl: './diario.component.css',
    standalone: false
})
export class DiarioComponent {
  @Input() telaPequena = false;
  loading = false;
  diaTexto = 0;
  diaAtual = new Date();
  mesTexto = '';
  anoTexto = 0;
  lista = new TarefasAgrupadasPorHora();

  constructor(private tarefaServico: TarefaService,
              private toastr: ToastrService) {
    this.buscarCompromissosDiario(new Date());
    this.setTextoData(this.diaAtual);

  }

  public adicionarDia(){
    this.loading = true;
    this.diaAtual.setDate(this.diaAtual.getDate() + 1);
    this.setTextoData(this.diaAtual);
    this.buscarCompromissosDiario(this.diaAtual);
  }

  public diminuirDia(){
    this.loading = true;
    this.diaAtual.setDate(this.diaAtual.getDate() - 1);
    this.setTextoData(this.diaAtual);
    this.buscarCompromissosDiario(this.diaAtual);
  }

  private setTextoData(dataAtual: Date){
    this.diaTexto = dataAtual.getDate();
    this.mesTexto = this.primeiraLetraMaiuscula(dataAtual.toLocaleString('pt-br', { month: 'long'}));
    this.anoTexto = dataAtual.getFullYear();
  }

  private primeiraLetraMaiuscula(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  buscarCompromissosDiario(dataHoje: Date){

    let hoje = dataHoje.toISOString().split('T')[0];
    this.tarefaServico.buscarCompromissosDiarioAgrupadoPorHora(hoje).subscribe(resultado => {
      if(resultado.sucesso){
        this.lista = resultado.dados;
      }
    });

    this.loading = false;
  }
}
